export default {
  data() {
    return {
      signupNoticeId: this.$route.query.signupNoticeId,
    };
  },
  created() {
    if(!this.signupNoticeId) this.$router.push("index");
  },
  methods: {
    async ajaxSearchSignupApply(params) {
      // 查询报名信息 #李茹钰/2019-03-12#
      this.$message.loading();
      let {error, data} = await this.$ajax.gateway("/bm-teacher/ITeacherSignupApi_searchApply", params);
      if(!error && data.code === 200){
        this.$message.hide();
        data = data.data;
        console.log("-> 查询成功", data.id);
        this.$router.push({
          path: "bm_info",
          query: {
            ...params,
            signupNoticeId: this.signupNoticeId
          }
        });
      }
    }
  }
};
